export const AANVRAAG = "AANVRAAG";
export const PROJECT = "PROJECT";
export const MINIMALEEISENALGEMEEN = "MINIMALEEISENALGEMEEN";
export const MINIMALEEISENINFRASTRUCTUUR = "MINIMALEEISENINFRASTRUCTUUR";
export const BOVENLOKALITEITPERINFRASTRUCTUUR = "BOVENLOKALITEITPERINFRASTRUCTUUR";
export const CRITERIABOVENLOKAAL = "CRITERIABOVENLOKAAL";
export const CRITERIATOPSPORT = "CRITERIATOPSPORT";
export const VOORTGANGSRAPPORT_PROJECT = "VOORTGANGSRAPPORT_PROJECT";
export const VOORTGANGSRAPPORT_BEOORDELINGSCRITERIA = "VOORTGANGSRAPPORT_BEOORDELINGSCRITERIA";
export const VOORTGANGSRAPPORT_VERANTWOORDING = "VOORTGANGSRAPPORT_VERANTWOORDING";
export const SIMULATIEDOSSIER = "SIMULATIEDOSSIER";
export const SIMULATIEPERINFRASTRUCTUUR = "SIMULATIEPERINFRASTRUCTUUR";
export const KOSTOPBRENGST = "KOSTOPBRENGST";
export const INVESTERINGEN = "INVESTERINGEN";
export const INFRASTRUCTUURINDEBUURT = "INFRASTRUCTUURINDEBUURT";